import React from 'react';
import { Button, Icon } from '@components';
import { ColorsEnum } from '@utilities/enums';
import { useNavigation } from '@utilities/hooks';

export const NotFoundPage: React.FC = () => {
    const { goBack } = useNavigation();

    return (
        <div className="flex flex-col items-center justify-center h-screen bg-base-200 text-center px-6 lg:px-0">
            <div className="flex flex-col items-center">
                <div className="rounded-full p-8 bg-primary-content shadow-lg mb-6">
                    <Icon iconName="Frown" size={100} color={ColorsEnum.PRIMARY} />
                </div>
                <h1 className="text-7xl font-bold text-primary mb-4">404</h1>
                <h2 className="text-3xl lg:text-4xl font-semibold text-base-content mb-6">
                    Page non trouvée
                </h2>
                <p className="text-base-content text-lg max-w-lg mb-8">
                    La page que vous recherchez a peut-être été déplacée ou n'existe pas.
                    Veuillez vérifier l'URL, ou cliquez ci-dessous pour revenir à l'accueil.
                </p>
                <Button
                    onClick={goBack}
                    className="btn-wide text-md"
                >
                    Retour à la page précédente
                </Button>
            </div>
        </div>
    );
};
